import { scmsService } from "../../services/site";
import { settings } from "../../common/setting";
import { user } from "../../user";
import $ from "jquery";
import { URLS } from "fire-wind-water";

function browseAction(): void {
  const info: any = {
    tenantId: settings.tenantId,
    siteId: settings.siteId,
    globalUserId: user.globalUserId,
    openId: user.openId || "",
    channel_code: settings.channel_code,
    memberId: user.memberId,
    sess: user.session,
    objTitle: document.title,
    objId: settings.siteId,
    actionKey: "",
    menuId: settings.menuId,
    pageId: settings.pageId,
    category: URLS.getURL("cy") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].cy:null)),
  };
  if (
    window.location.href.indexOf("/fileinfo_") > -1 ||
    window.location.href.indexOf("/fileInfo_") > -1
  ) {
    const title = $("#file-title")
      .text()
      .replace(/[ ]|[\r\n]/g, "");
    const filename = window.location.href.split("/").pop();
    // const objId = filename.slice(0, filename.lastIndexOf(".")).split("_")[2];
    info.objTitle = title;
    info.fid = URLS.getURL("fid");
    info.actionKey = "FILE";
  }
  if (
    window.location.href.indexOf("/articleinfo") > -1 ||
    window.location.href.indexOf("/articleInfo") > -1
  ) {
    const title = $(".article-title")
      .text()
      .replace(/[ ]|[\r\n]/g, "");
    const filename = window.location.href.split("/").pop();
    // const objId = filename.slice(0, filename.lastIndexOf(".")).split("_")[2];
    info.objTitle = title;
    info.aid = URLS.getURL("aid");
    info.actionKey = "MIMAGETEXT";
  }
  if (
    window.location.href.indexOf("/articlelist") > -1 ||
    window.location.href.indexOf("/articleList") > -1
  ) {
    // 文章列表
    const url = window.location.href;
    info.objTitle = document.title;
    info.actionKey = "MIMAGETEXT_LIST";
  }
  if (
    window.location.href.indexOf("/filelist_") > -1 ||
    window.location.href.indexOf("/fileList") > -1
  ) {
    // 文件列表
    const url = window.location.href;
    info.objTitle = document.title;
    info.actionKey = "FILE_LIST";
  }
  if (
    window.location.href.indexOf("videolist") > -1 ||
    window.location.href.indexOf("videoList") > -1
  ) {
    // 视频列表
    const url = window.location.href;
    info.objTitle = document.title;
    info.actionKey = "VIDEO_LIST";
  }
  if (
    window.location.href.indexOf("meetinglist") > -1 ||
    window.location.href.indexOf("meetingList") > -1
  ) {
    // 会议列表
    const url = window.location.href;
    info.objTitle = document.title;
    info.actionKey = "MEETING_LIST";
  }
  if (window.location.href.indexOf("blanklist") > -1) {
    // 空白页面
    const url = window.location.href;
    info.objTitle = document.title;
    info.actionKey = "CUSTOMCONTENT_LIST";
  }
  scmsService.browse(info);
}

export function actionBrowse(): any {
  // 非正式链接不记录互动行为
  if (settings.isDesign) {
    return;
  }
  browseAction();
}
